import { render, staticRenderFns } from "./DocCard.vue?vue&type=template&id=0da72fae"
import script from "./DocCard.vue?vue&type=script&lang=js"
export * from "./DocCard.vue?vue&type=script&lang=js"
import style0 from "./DocCard.vue?vue&type=style&index=0&id=0da72fae&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports